import { EditOutlined } from "@ant-design/icons";
import { Button, Card, List } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";

const { Item } = List;
// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function AddressCard(props: any) {
  const { address = {}, loading, onEdit } = props;
  function EditButton() {
    return (
      <Button type="primary" icon={<EditOutlined />} onClick={onEdit}>
        Edit
      </Button>
    );
  }

  return (
    <Card title="Address" loading={loading} extra={<EditButton />}>
      <List itemLayout="vertical">
        <Item>
          <Item.Meta
            title="Street"
            description={`${address.streetNumber || ""} ${address.streetName || ""} ${
              address.subpremise || ""
            }`}
          />
          <Item.Meta title="Apartment/Floor/Building" description={address.line1 || "---"} />
          <Item.Meta title="City" description={address.city} />
          <Item.Meta title="State" description={address.state} />
          <Item.Meta title="Postal Code" description={address.postalCode} />
        </Item>
      </List>
    </Card>
  );
}
